import React from 'react';
import storage from 'redux-persist/lib/storage';

const Logout: React.FC = () => {
  const clear = () => {
    window.console.log('Removing redux persistent data.');
    storage.removeItem('persist:root');
    window.location.reload();
    return true;
  };
  return (
    <div className="grid h-screen place-items-center">
      <p>You have been partially logged out.</p>
      <p>
        Please{' '}
        <a onClick={clear} href="#" className="underline hover:bg-primary-200">
          click here
        </a>{' '}
        to finish logout and start a new session.
      </p>
    </div>
  );
};

export default Logout;
